import { Box } from "@outschool/backpack";
import React from "react";

import AvailableTimesRows from "../../AvailableTimesInput/AvailableTimesRows";
import { AvailableTime } from "../../AvailableTimesInput/types";
import QuickSelectTimeBucketButtons from "./AvailableTimesQuickSelectButtons";

type AvailableTimesInputProps = {
  availableTimes: AvailableTime[];
  onUpdateAll: (_at: AvailableTime[]) => void;
};

export default function AvailableTimesInput({
  availableTimes,
  onUpdateAll,
}: AvailableTimesInputProps) {
  const handleDeleteAvailableTime = React.useCallback(
    (deleted: AvailableTime) => {
      const updatedAvailabilities = availableTimes.filter(
        ea => ea.uid !== deleted.uid,
      );
      onUpdateAll(updatedAvailabilities);
    },
    [onUpdateAll, availableTimes],
  );

  const handleUpdateAvailableTime = React.useCallback(
    (updated: AvailableTime) => {
      const updatedAvailabilities = availableTimes
        .filter(av => av.uid !== updated.uid)
        .concat([updated]);
      onUpdateAll(updatedAvailabilities);
    },
    [onUpdateAll, availableTimes],
  );

  return (
    <>
      <Box sx={{ marginBottom: "2.4rem" }}>
        <QuickSelectTimeBucketButtons
          availableTimes={availableTimes}
          onUpdateAll={onUpdateAll}
        />
      </Box>
      <Box>
        <AvailableTimesRows
          availableTimes={availableTimes}
          onDelete={handleDeleteAvailableTime}
          onUpdate={handleUpdateAvailableTime}
        />
      </Box>
    </>
  );
}
